// Import the functions you need from the SDKs you need
// Import the functions you need from the SDKs you need

import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"
import { getAuth , signOut   } from "firebase/auth";
import 'firebase/compat/storage';
import firebase from 'firebase/compat/app';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional




const firebaseConfig = {
  apiKey: "AIzaSyBCKs7VOOnc3dk4TNUiVwfqb07KhRuAVd4",
  authDomain: "junglekeepers-f910a.firebaseapp.com",
  projectId: "junglekeepers-f910a",
  storageBucket: "junglekeepers-f910a.appspot.com",
  messagingSenderId: "459622427699",
  appId: "1:459622427699:web:087ab29bde730537d9c746"
};
const app = initializeApp(firebaseConfig);
firebase.initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const database = getFirestore(app);
export const storage = getStorage(app)
export const auth = getAuth(app);
export const Signout = signOut(auth);
export const StorageFolder = firebase.storage();
// export const database = firebase.firestore();
// export const storage = firebase.storage()
// export const auth = firebase.auth();
// export const Signout = () => auth.signOut(); // Corrected way to call signOut
// export const StorageFolder = firebase.storage()

// if (window.location.hostname.includes('localhost')) {
//   database.useEmulator("localhost", 8080);
//   storage.useEmulator("http://localhost:4000", 9199);
//   auth.useEmulator("http://localhost:4000");
//   StorageFolder.useEmulator("http://localhost:4000", 9199);
// }

export default firebase;
